// Reusable cursive letter data structures.
// Coordinate system: SVG viewBox "0 0 100 100" (normalized) so scoring works on any screen.
// Handwriting guidelines (y values): top (ascender), mid (dashed x-height top), base (baseline), bottom (descender).

export const GUIDELINES = { top: 16, mid: 48, base: 82, bottom: 95 };

export const LETTERS = {
  a: {
    id: "a",
    displayName: "Lowercase a",
    viewBox: "0 0 100 100",
    difficulty: "beginner",
    strokeCount: 1,
    masteryScore: 80,
    level: 2,
    guidelines: GUIDELINES,
    startingPoint: { x: 60, y: 52 },
    strokes: [
      {
        // oval (counter-clockwise) then the down-stroke on the right with an exit tail
        d: "M 60 52 C 52 45 39 46 33 55 C 27 64 30 76 40 79 C 49 82 58 78 59 68 C 59 62 59 56 59 52 L 59 79 C 61 84 67 83 72 78",
        direction: "ccw",
      },
    ],
    get fullPath() {
      return this.strokes.map((s) => s.d).join(" ");
    },
  },

  b: {
    id: "b",
    displayName: "Lowercase b",
    viewBox: "0 0 100 100",
    difficulty: "beginner",
    strokeCount: 1,
    masteryScore: 80,
    level: 2,
    guidelines: GUIDELINES,
    startingPoint: { x: 29, y: 80 },
    strokes: [
      {
        // tall entry loop up to the top line, back down the stem, then the belly + exit
        d: "M 29 80 C 33 56 38 30 41 17 C 42 13 46 15 44 23 C 41 43 37 63 38 77 C 41 84 55 85 61 74 C 66 65 58 57 48 61 C 43 63 45 71 54 71 C 60 71 66 69 71 67",
        direction: "cw",
      },
    ],
    get fullPath() {
      return this.strokes.map((s) => s.d).join(" ");
    },
  },

  c: {
    id: "c",
    displayName: "Lowercase c",
    viewBox: "0 0 100 100",
    difficulty: "beginner",
    strokeCount: 1,
    masteryScore: 80,
    level: 2,
    guidelines: GUIDELINES,
    startingPoint: { x: 63, y: 56 },
    strokes: [
      {
        // open arc, counter-clockwise
        d: "M 63 56 C 58 47 47 44 39 49 C 29 55 27 70 34 77 C 40 83 51 83 61 76",
        direction: "ccw",
      },
    ],
    get fullPath() {
      return this.strokes.map((s) => s.d).join(" ");
    },
  },
};

export const LETTER_ORDER = ["a", "b", "c"];

export const getLetter = (id) => LETTERS[id];
